// version.js
const version = require('../package.json').version;

export default version;